import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { TestComponent } from './components/test/test.component';
import { AuthGuard } from './_guards/auth.guard';
import { RoutePanelComponent } from './components/route-panel/route-panel.component';
import { PromoAuthGuard } from './_guards/promo-auth.guard';
import { SwitchAuthGuard } from './_guards/switch-guard';
const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  { path: 'app', component: TestComponent, canActivate: [AuthGuard] },
  {
    path: 'accountSettings',
    loadChildren: () =>
      import('./account-setting/account-setting.module').then(
        (m) => m.AccountSettingModule
      ),
  },
  {
    path: 'applicationSettings',
    loadChildren: () =>
      import('./application-settings/application-settings.module').then(
        (m) => m.ApplicationSettingsModule
      ),
  },
  {
    path: 'routeProfiles',
    loadChildren: () =>
      import('./route-profiles/route-profiles.module').then(
        (m) => m.RouteProfilesModule
      ),
  },
  { path: 'Route', component: RoutePanelComponent, canActivate: [AuthGuard] },
  {
    path: 'savedRoute/:id',
    component: TestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'promo/:authToken',
    component: TestComponent,
    canActivate: [PromoAuthGuard],
  },
  {
    path: 'switchmodern/:username/:accountname/:authToken',
    component: TestComponent,
    canActivate: [SwitchAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    const currentUser = localStorage.getItem('currentUser');
    this.router.errorHandler = (error) => {
      if (currentUser) {
        this.router.navigate(['/app']);
      } else {
        this.router.navigate(['/landing']);
      }
    };
  }
}
